import React, { useState, useEffect } from 'react'
import './AccessPage.scss'
import * as _ from 'lodash'
import Login from '../components/Login'
import Registration from '../components/Registration'
import ResetPassword from '../components/ResetPassword'
import { scrollBodyTop } from '../hooks/scrollPosition'
import { CambiarColoresPrincipales } from '../hooks/config'

const AccessPage = () => {
    const [loginOrRegistration, setLoginOrRegistration] = useState('login')

    useEffect(() => {
        scrollBodyTop()
        CambiarColoresPrincipales('fansa')
    }, [])

    // componentWillUnmount using useEffect
    useEffect(() => {
        return () => {
          CambiarColoresPrincipales()
        }
    }, [])

    const clickChangeRegistrationLogin = (value) => {
        setLoginOrRegistration(value)
    }
    return (
        <div className="access-page-container">
            <div className="access-content">
                {
                    loginOrRegistration === 'login' &&
                    <Login clickChangeRegistrationLogin={clickChangeRegistrationLogin} />
                }
                {
                    loginOrRegistration === 'reset' &&
                    <ResetPassword clickChangeRegistrationLogin={clickChangeRegistrationLogin} />
                }
                {
                    loginOrRegistration === 'registration' &&
                    <Registration clickChangeRegistrationLogin={clickChangeRegistrationLogin} />
                }
            </div>
        </div>
    )
}

export default AccessPage
